import React, { PropsWithChildren } from 'react';

import { useDonationUserSearch } from '@/core/lib/new-architecture/actions/savedSearch.actions';

interface OptionToDisplayProps extends PropsWithChildren {
  title: string;
  onSelectHistoricalSearch: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const OptionToDisplay: React.FC<OptionToDisplayProps> = ({ title, onSelectHistoricalSearch, children }) => {
  const { donationUserSearchDeleteMutation } = useDonationUserSearch();

  return (
    <div className="flex w-full items-center justify-between">
      <button
        type="button"
        className="text-body-secondary inline-flex w-full cursor-pointer items-center justify-start gap-1 bg-bg-primary px-3 py-4 text-start font-medium text-content-primary hover:bg-bg-pale"
        onClick={onSelectHistoricalSearch}
        disabled={donationUserSearchDeleteMutation.isPending}
      >
        {title}
      </button>
      {children}
    </div>
  );
};

export default OptionToDisplay;
